module.exports = __webpack_public_path__ + "img/expired-coupon-icon.98b9a751.png";